"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgLikeFilled = function (props) {
    var color = props.color;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M9 22C8.44772 22 8 21.5523 8 21V9C8 8.5 8.3055 7.68837 8.5 7.5L12.4416 2.72991C12.9089 2.26256 13.5428 2 14.2037 2C16.0563 2 16.5253 3.94957 15.6968 5.60655L14.5001 8H20.0001C21.1047 8 22.0001 8.89543 22.0001 10V14.018C22.0001 14.4495 21.907 14.8758 21.7273 15.268L19.4439 20.25C18.9551 21.3163 17.8897 22 16.7167 22H9Z", fill: color }),
        React.createElement("path", { d: "M4 8C2.89543 8 2 8.89543 2 10V20C2 21.1046 2.89543 22 4 22C5.10457 22 6 21.1046 6 20V10C6 8.89543 5.10457 8 4 8Z", fill: color })));
};
exports.default = factorySvgIcon_1.default(SvgLikeFilled);
//# sourceMappingURL=SvgLikeFilled.js.map